module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Frame.e0fa4088.png";